import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Select from "react-select";
import { restbaseurl } from '../globals/constants';
import { RestDataSource } from '../utils/RestDataSource';
import ConfirmationModal from '../globals/uicomps/ConfirmationModal';
import UserInfo from '../models/UserInfo';
import { getValue } from '../globals/utils';
import { BTSelectField } from '../globals/uicomps/BTSelectField';

import DialogModal from '../globals/uicomps/DialogModal';
import AddressDetailsModal from './AddressDetailsModal';

class VerificationStatusDetails extends Component {
     constructor(props) {
          super(props);
          this.state = {
               loading: false,
               vendorName: '',
               dummy: false,
               vendorId: this.props.vendorDetails.currentId,
               unAssign: false,
               subheading: '',
               showConfirmationModal: false,
               vendorOptions: this.props.vendorOptions,
               address: '',
               openAddressDetailsModal: false,
               payloadData: null
          };
          // this.vendorOptions = []
          this.totalVendorList = [];

          getValue().then((pLData) => {
               this.setState({ payloadData: pLData });
          });
     }

     handleResidenceChange = () => {
          this.saveResidence = new RestDataSource(
               `${restbaseurl}/residence/reAssignVendor`
          );
          this.setState({ loading: true }, () => {
               this.saveResidence.GetData(
                    data => {
                         if (data.status === true) {
                              this.setState({
                                   showConfirmationModal: false,
                                   cbRender: this.props.cbRender()
                              })
                         }
                    },
                    {
                         "vendorId": this.state.vendorId,
                         "id": this.props.vendorDetails.resId
                    },
                    "POST"
               );
          });
     }

     handleDrugChange = (isReAssign) => {
          let action = '';
          if (isReAssign) {
               action = 'reAssignVendor';
          }
          else {
               action = 'assignVendor';
          }
          this.saveDrug = new RestDataSource(
               `${restbaseurl}/drug/${action}`
          );
          this.setState({ loading: true }, () => {
               this.saveDrug.GetData(
                    data => {
                         if (data.status === true) {
                              this.setState({
                                   showConfirmationModal: false,
                                   cbRender: this.props.cbRender()
                              })
                         }
                    },
                    {
                         "vendorId": this.state.vendorId,
                         "id": this.props.vendorDetails.drugId,
                         userId: UserInfo.getUserid(),
                    },
                    "POST"
               );
          });
     }



     handleCreditChange = (isReAssign) => {
          let action = '';
          if (isReAssign) {
               action = 'reAssignVendor';
          }
          else {
               action = 'assignVendor';
          }
          this.saveCibil = new RestDataSource(
               `${restbaseurl}/cibil/${action}`
          );
          this.setState({ loading: true }, () => {
               this.saveCibil.GetData(
                    data => {
                         if (data.status === true) {
                              this.setState({
                                   showConfirmationModal: false,
                                   cbRender: this.props.cbRender()
                              })
                         }
                    },
                    {
                         "vendorId": this.state.vendorId,
                         "id": this.props.vendorDetails.creditId,
                         userId: UserInfo.getUserid(),
                    },
                    "POST"
               );
          });
     }

     
     handleEducationChange = (isReAssign) => {
          let action = '';
          if (isReAssign) {
               action = 'reAssignVendor';
          }
          else {
               action = 'assignVendor';
          }
          this.saveDrug = new RestDataSource(
               `${restbaseurl}/education/${action}`
          );
          this.setState({ loading: true }, () => {
               this.saveDrug.GetData(
                    data => {
                         if (data.status === true) {
                              this.setState({
                                   showConfirmationModal: false,
                                   cbRender: this.props.cbRender()
                              })
                         }
                    },
                    {
                         "vendorId": this.state.vendorId,
                         "id": this.props.vendorDetails.eduId,
                         userId: UserInfo.getUserid(),
                    },
                    "POST"
               );
          });
     }

     confirmSuccessCallback = () => {
          switch (this.currentCheckType) {
               case 'residence':
                    if (this.state.unAssign) {
                         this.unAssignVendor()
                    } else {
                         this.handleResidenceChange()
                    }
                    break;
               case 'cibil':
                    if (this.state.unAssign) {
                         this.unAssignVendor()
                    } else {
                         if (this.props.vendorDetails.currentId && this.props.vendorDetails.currentId !== '' && this.props.vendorDetails.currentId !== null) {
                              this.handleCreditChange(true)
                         } else {
                              this.handleCreditChange(false)
                         }
                    }
                    break;
               case 'drug':
                    if (this.state.unAssign) {
                         this.unAssignVendor()
                    } else {
                         if (this.props.vendorDetails.currentId && this.props.vendorDetails.currentId !== '' && this.props.vendorDetails.currentId !== null) {
                              this.handleDrugChange(true)
                         } else {
                              this.handleDrugChange(false)
                         }

                    }
                    break;
               case 'education':
                    if (this.state.unAssign) {
                         this.unAssignVendor()
                    } else {
                         if (this.props.vendorDetails.currentId && this.props.vendorDetails.currentId !== '' && this.props.vendorDetails.currentId !== null) {
                              this.handleEducationChange(true)
                         } else {
                              this.handleEducationChange(false)
                         }

                    }
                    break;
               default:
                    break
          }

     }

     unAssignVendor = () => {
          const currentCheckType = this.currentCheckType;
          this.unAssign = new RestDataSource(
               `${restbaseurl}/${currentCheckType}/unassignVendor`
          );
          let id = '';
          if (currentCheckType === 'residence') {
               id = this.props.vendorDetails.resId;
          } else if (currentCheckType === 'cibil') {
               id = this.props.vendorDetails.creditId;
          } else if (currentCheckType === 'drug') {
               id = this.props.vendorDetails.drugId;
          }

          this.setState({ loading: true }, () => {
               this.unAssign.GetData(
                    data => {
                         if (data.status === true) {
                              // this.vendorOptions = this.totalVendorList;
                              this.setState({
                                   showConfirmationModal: false,
                                   unAssign: false,
                                   cbRender: this.props.cbRender()
                              })
                         }
                    },
                    {
                         "id": id,
                         userId: UserInfo.getUserid(),
                    },
                    "POST"
               );
          });
     }

     onVendorChange = (event) => {
          this.setState({
               vendorName: event.label,
               vendorId: event.value,
               showConfirmationModal: true,
               unAssign: false,
               subheading: `Do you want to assign  ${event.label} to this check `
          })
     }

     unAssignVendorConfirmation = () => {
          this.setState({
               showConfirmationModal: true,
               unAssign: true,
               subheading: `Do you want to UnAssign vendor to this case `
          })
     }

     generateAddressListOptions = () => {
          let addressList = this.props.addressList
          this.addressOptionTags = addressList.map(row => {
               return <option key={String(row.id)} value={row.id + '-' + row.code + '-' + row.drugId}>{row.address}</option>
          });
          this.addressOptionTags = [<option id="0" key="0" value="">Select one</option>, ...this.addressOptionTags]
          return this.addressOptionTags;
     }

     handleChange = () => {
          let addressElement = document.getElementById("address")
          if (addressElement && 'value' in addressElement) {
               let selectedValue = addressElement.value
          this.setState({
               address: selectedValue
          })
          }
     }

     saveAddress = () => {
          this.source = new RestDataSource(`${restbaseurl}/drug/tagAddress`);
          this.setState({ loading: true }, () => {
               this.source.GetData(
                    data => {
                         if (data.status === true) {
                              this.props.cbRender()
                         }
                    },
                    { addressStr: this.state.address },
                    "POST"
               );
          });
     }

     addNewAddress = () => {
          this.preventRender = true
          this.setState({
               openAddressDetailsModal: true
          })
     }

     hideModal = () => {
          this.setState({ showdialog: false, openAddressDetailsModal: false });
     };

     // Download UAN file
     downloadUanFile = (downloadData, fileName) => {
          try {
               // Use the same logic as downloadUanFileFromUrl since both handle base64 and URLs
               this.downloadUanFileFromUrl(downloadData, fileName);
          } catch (error) {
               console.error('Error downloading UAN file:', error);
               alert(`Error downloading ${fileName}. Please try again.`);
          }
     }

     // Download UAN report PDF
     downloadUanReportPdf = (downloadUrl) => {
          try {
               // Create a temporary link element and trigger download
               const link = document.createElement('a');
               link.href = downloadUrl;
               link.download = 'UAN_Report.pdf';
               link.target = '_blank';
               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);
               
               // Show success message (you can add a toast notification here if available)
               console.log('Downloading UAN Report PDF...');
          } catch (error) {
               console.error('Error downloading UAN report PDF:', error);
          }
     }

     // Download UAN file from URL or base64 data (for raw UAN Files data)
     downloadUanFileFromUrl = (downloadData, fileName) => {
          try {
               // If a long URL with base64 in query was provided, extract and handle locally
               if (typeof downloadData === 'string' && downloadData.indexOf('/downloadUanDocument') !== -1 && downloadData.indexOf('docData=') !== -1) {
                    try {
                         const url = new URL(downloadData, window.location.origin)
                         const docDataParam = url.searchParams.get('docData')
                         const docNameParam = url.searchParams.get('docName') || fileName
                         if (docDataParam) {
                              const decoded = decodeURIComponent(docDataParam)
                              this.downloadFromBase64(decoded, docNameParam || fileName)
                              return
                         }
                    } catch (e) {
                         // fall through
                    }
               }

               // Base64 (data URL or raw)
               if (this.isBase64Data(downloadData)) {
                    this.downloadFromBase64(downloadData, fileName)
                    return
               }

               // Regular URL
               const link = document.createElement('a')
               const resolvedUrl = (typeof downloadData === 'string' && downloadData.charAt(0) === '/') ? `${restbaseurl}${downloadData}` : downloadData
               link.href = resolvedUrl
               link.download = fileName
               link.target = '_blank'
               document.body.appendChild(link)
               link.click()
               document.body.removeChild(link)
          } catch (error) {
               console.error('Error downloading UAN file:', error)
               alert(`Error downloading ${fileName}. Please try again.`)
          }
     }

     // Check if the data is base64 encoded
     isBase64Data = (data) => {
          // Check for data URL format or plain base64
          return data.startsWith('data:') || this.isValidBase64(data);
     }

     // Validate base64 string
     isValidBase64 = (str) => {
          try {
               // Basic base64 pattern check
               const base64Pattern = /^[A-Za-z0-9+/]*={0,2}$/;
               return base64Pattern.test(str) && str.length > 100; // Reasonable length for PDF
          } catch (error) {
               return false;
          }
     }

     // Download file directly from base64 data
     downloadFromBase64 = (base64Data, fileName) => {
          try {
               let dataUrl = base64Data;
               
               // If it's not already a data URL, create one
               if (!base64Data.startsWith('data:')) {
                    dataUrl = `data:application/pdf;base64,${base64Data}`;
               }
               
               // Convert data URL to blob
               const byteCharacters = atob(dataUrl.split(',')[1]);
               const byteNumbers = new Array(byteCharacters.length);
               for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
               }
               const byteArray = new Uint8Array(byteNumbers);
               const blob = new Blob([byteArray], { type: 'application/pdf' });
               
               // Create blob URL and trigger download
               const url = window.URL.createObjectURL(blob);
               const link = document.createElement('a');
               link.href = url;
               link.download = fileName;
               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);
               window.URL.revokeObjectURL(url);
               
               console.log(`Downloaded ${fileName} successfully from base64 data`);
          } catch (error) {
               console.error('Error downloading from base64:', error);
               alert(`Error downloading ${fileName}. The file data may be corrupted.`);
          }
     }

     // Parse raw UAN files string to extract file information and download data
     parseUanFilesString = (uanFilesString) => {
          try {
               console.log('DEBUG: Parsing UAN files string:', uanFilesString);
               const files = [];
               
               // Split by " | " to get individual file entries
               const fileEntries = uanFilesString.split(' | ');
               
               fileEntries.forEach((entry, index) => {
                    if (entry && entry.trim()) {
                         // Parse pattern: "filename [Download: base64-data-or-url]"
                         const downloadMatch = entry.match(/^(.+?)\s*\[Download:\s*(.+?)\]$/);
                         
                         if (downloadMatch) {
                              const fileName = downloadMatch[1].trim();
                              const downloadData = downloadMatch[2].trim();
                              console.log('DEBUG: Parsed file - Name:', fileName, 'Data type:', this.isBase64Data(downloadData) ? 'base64' : 'url', 'Data preview:', downloadData.substring(0, 100));
                              
                              // Determine file type from file name
                              let fileType = 'Document';
                              if (fileName.toLowerCase().includes('bgv')) {
                                   fileType = 'BGV Form';
                              } else if (fileName.toLowerCase().includes('evidence')) {
                                   fileType = 'Evidence';
                              } else if (fileName.toLowerCase().includes('uan')) {
                                   fileType = 'UAN Document';
                              }
                              
                              files.push({
                                   fileName: fileName,
                                   downloadUrl: downloadData, // This can now be base64 data or URL
                                   fileType: fileType
                              });
                         } else {
                              // Fallback: treat entire entry as filename without download data
                              files.push({
                                   fileName: entry.trim(),
                                   downloadUrl: '#',
                                   fileType: 'Document'
                              });
                         }
                    }
               });
               
               return files;
          } catch (error) {
               console.error('Error parsing UAN files string:', error);
               return [{
                    fileName: 'Error parsing file data',
                    downloadUrl: '#',
                    fileType: 'Error'
               }];
          }
     }

     render = () => {
          const { t } = this.props
          let value = this.props.obj[this.props.data]
          let showReassignVendor = false, addAddress = false
          let showRemoveVendor = false
          // Hide UAN-specific frontend-only sections in dashboard view
          if (this.props.data === 'UAN Files For Frontend' || this.props.data === 'UAN Report Data For Frontend') {
               return null
          }
          const { openAddressDetailsModal } = this.state;
          if (this.state.payloadData) {
               let roleCode = this.state.payloadData["roleCode"];
               if (this.props.data === "Process Status" && value !== "Completed" && this.props.vendorDetails.reassign === true
                    && this.state.payloadData['rolePriority'] !== this.state.payloadData['roleMap']['ca'] && this.state.payloadData['rolePriority'] !== this.state.payloadData['roleMap']['hr']) {
                    showReassignVendor = true
               }
               if (this.props.verificationType === "Drug Check" && this.props.data === "Address List" && (roleCode === "chp" || roleCode === "admin")) {
                    addAddress = true
               }
               
               if ((this.props.vendorDetails.currentId !== null && this.props.data === "Vendor Name" && this.state.payloadData['rolePriority'] <= this.state.payloadData['roleMap']['operationshead'] && this.props.obj['Process Status'] !== 'Completed')) {
                    showRemoveVendor = true
               }
               this.vendorOptions = this.totalVendorList.filter(data => data.value !== this.props.vendorDetails.currentId);
               if (this.props.verificationType === "Residence Check") {
                    this.currentCheckType = 'residence'
               } else if (this.props.verificationType === "Credit Check") {
                    this.currentCheckType = 'cibil'
               } else if (this.props.verificationType === "Drug Check") {
                    this.currentCheckType = 'drug'
               } else if (this.props.verificationType === "Education Check") {
                    this.currentCheckType = 'education'
               }

               if (this.props.data === "Address List") {
                    value = value.map(addressObj => {
                         return (
                              <React.Fragment>
                                   <div>{addressObj.address}</div>
                              </React.Fragment>
                         )
                    })
               }
          }

          return (
               <React.Fragment>
                    {addAddress ?
                         <React.Fragment>
                              <div className="col-12 col-sm-6 mb15 ml5 mr5">
                                   <React.Fragment>
                                        <BTSelectField
                                             id="address"
                                             label="Add Address"
                                             onChange={this.handleChange}
                                             value={this.state.address}
                                             options={this.generateAddressListOptions()}
                                             required={true} />
                                        <div style={{ marginTop: '-15px' }}>
                                             <div className="btn btn_secondary_light btn_secondary right" onClick={this.addNewAddress}>{t("add_Address")} </div>
                                             <div className="btn btn_secondary_light btn_secondary right mr-2" onClick={this.saveAddress}>{t("save")} </div>
                                        </div>
                                   </React.Fragment>
                              </div>
                         </React.Fragment>
                         :
                         <div className={this.props.data === 'Document String' ? "col-12 col-sm-12 mb15" : "col-12 col-sm-6 mb15"}>
                              <div className="smallfont">{
                                   this.props.data ? (this.props.data) : ' - '}
                                   {(showRemoveVendor) ? <img alt="icon-close" src={'/images/icons/icon-close.svg'} className="remove_vendor pointer" onClick={this.unAssignVendorConfirmation} /> : null}
                              </div>
                              <div className="clr5"></div>
                              
                              {/* Enhanced UAN Files Display */}
                              {this.props.data === 'UAN Files For Frontend' && Array.isArray(value) && value.length > 0 ? (
                                   <div className="uan-files-section">
                                        <div style={{ marginBottom: '10px' }}>
                                             <strong style={{ color: '#007bff', fontSize: '14px' }}>
                                                  📄 UAN Documents ({value.length})
                                             </strong>
                                        </div>
                                        {value.map((file, index) => (
                                             <div key={index} className="file-download-item" style={{ 
                                                  marginBottom: '8px', 
                                                  padding: '12px', 
                                                  border: '1px solid #e3e6f0', 
                                                  borderRadius: '8px',
                                                  backgroundColor: '#f8f9fc',
                                                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                             }}>
                                                  <div className="row align-items-center">
                                                       <div className="col-8">
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                 <span style={{ 
                                                                      fontSize: '18px', 
                                                                      marginRight: '8px',
                                                                      color: file.fileType === 'bgv' ? '#28a745' : '#17a2b8'
                                                                 }}>
                                                                      {file.fileType === 'bgv' ? '📝' : '📋'}
                                                                 </span>
                                                                 <div>
                                                                      <div style={{ 
                                                                           fontWeight: '600', 
                                                                           fontSize: '13px',
                                                                           color: '#2c3e50',
                                                                           marginBottom: '2px'
                                                                      }}>
                                                                           {file.fileName.length > 25 ? `${file.fileName.substring(0, 25)}...` : file.fileName}
                                                                      </div>
                                                                      <div style={{ 
                                                                           fontSize: '11px', 
                                                                           color: '#6c757d',
                                                                           display: 'flex',
                                                                           alignItems: 'center'
                                                                      }}>
                                                                           <span style={{ 
                                                                                backgroundColor: file.fileType === 'bgv' ? '#d4edda' : '#d1ecf1',
                                                                                color: file.fileType === 'bgv' ? '#155724' : '#0c5460',
                                                                                padding: '2px 6px',
                                                                                borderRadius: '12px',
                                                                                fontSize: '10px',
                                                                                fontWeight: '500'
                                                                           }}>
                                                                                {file.fileType === 'bgv' ? 'BGV Form' : 'Evidence'}
                                                            </span>
                                                                      </div>
                                                                 </div>
                                                            </div>
                                                       </div>
                                                       <div className="col-4 text-right">
                                                            <button 
                                                                 className="btn btn-sm"
                                                                 style={{
                                                                      backgroundColor: file.fileType === 'bgv' ? '#28a745' : '#17a2b8',
                                                                      borderColor: file.fileType === 'bgv' ? '#28a745' : '#17a2b8',
                                                                      color: 'white',
                                                                      fontSize: '11px',
                                                                      padding: '4px 8px',
                                                                      borderRadius: '4px'
                                                                 }}
                                                                 onClick={() => this.downloadUanFile(file.downloadUrl, file.fileName)}
                                                                 title={`Download ${file.fileName}`}
                                                            >
                                                                 📥 Download
                                                            </button>
                                                       </div>
                                                  </div>
                                             </div>
                                        ))}
                                   </div>
                              ) : this.props.data === 'UAN Files For Frontend' && (!value || !Array.isArray(value) || value.length === 0) ? (
                                   <div style={{ 
                                        padding: '10px', 
                                        backgroundColor: '#fff3cd', 
                                        border: '1px solid #ffeaa7', 
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        color: '#856404'
                                   }}>
                                        ⚠️ No UAN documents uploaded
                                   </div>
                              ) : this.props.data === 'UAN Report Data For Frontend' && value && value.hasData ? (
                                   <div className="uan-report-section">
                                        <div style={{ marginBottom: '10px' }}>
                                             <strong style={{ color: '#28a745', fontSize: '14px' }}>
                                                  📊 UAN Employment Report
                                             </strong>
                                        </div>
                                        <div className="file-download-item" style={{ 
                                             marginBottom: '10px', 
                                             padding: '12px', 
                                             border: '1px solid #d4edda', 
                                             borderRadius: '8px',
                                             backgroundColor: '#f8fff9',
                                             boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                        }}>
                                             <div className="row align-items-center">
                                                  <div className="col-8">
                                                       <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span style={{ fontSize: '18px', marginRight: '8px' }}>📈</span>
                                                            <div>
                                                                 <div style={{ 
                                                                      fontWeight: '600', 
                                                                      fontSize: '13px',
                                                                      color: '#2c3e50',
                                                                      marginBottom: '4px'
                                                                 }}>
                                                                      UAN Employment History Report
                                                                 </div>
                                                                 <div style={{ fontSize: '11px', color: '#6c757d' }}>
                                                                      <div style={{ marginBottom: '2px' }}>
                                                                           <strong>UAN:</strong> <span style={{ color: '#007bff' }}>{value.uanNumber}</span>
                                                                      </div>
                                                                      <div style={{ marginBottom: '2px' }}>
                                                                           <strong>Records:</strong> {value.totalRecords} employment records
                                                                      </div>
                                                                      <div>
                                                                           <strong>Date:</strong> {value.verificationDate ? new Date(value.verificationDate).toLocaleDateString() : 'N/A'}
                                                                      </div>
                                                                 </div>
                                                            </div>
                                                       </div>
                                                  </div>
                                                  <div className="col-4 text-right">
                                                       <button 
                                                            className="btn btn-sm btn-success"
                                                            style={{
                                                                 fontSize: '11px',
                                                                 padding: '4px 8px',
                                                                 borderRadius: '4px'
                                                            }}
                                                            onClick={() => this.downloadUanReportPdf(value.downloadUrl)}
                                                            title="Download UAN Employment History PDF"
                                                       >
                                                            📄 Download PDF
                                                       </button>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              ) : this.props.data === 'UAN Report Data For Frontend' && value && !value.hasData ? (
                                   <div style={{ 
                                        padding: '10px', 
                                        backgroundColor: '#f8d7da', 
                                        border: '1px solid #f5c6cb', 
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        color: '#721c24'
                                   }}>
                                        ❌ No UAN report data available
                                   </div>
                              ) : this.props.data === 'UAN Files' && value && typeof value === 'string' && value.trim() !== '' && value !== 'No UAN Files Available' ? (
                                   (() => {
                                        const parsedFiles = this.parseUanFilesString(value);
                                        return parsedFiles.length > 0 ? (
                                             <div className="uan-files-section">
                                                  <div style={{ marginBottom: '10px' }}>
                                                       <strong style={{ color: '#6c757d', fontSize: '14px' }}>
                                                            📎 UAN Files ({parsedFiles.length})
                                                       </strong>
                                                  </div>
                                                  {parsedFiles.map((fileInfo, index) => (
                                             <div key={index} className="file-download-item" style={{ 
                                                  marginBottom: '8px', 
                                                  padding: '12px', 
                                                  border: '1px solid #e3e6f0', 
                                                  borderRadius: '8px',
                                                  backgroundColor: '#f8f9fc',
                                                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                             }}>
                                                  <div className="row align-items-center">
                                                       <div className="col-8">
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                 <span style={{ 
                                                                      fontSize: '18px', 
                                                                      marginRight: '8px',
                                                                      color: '#6c757d'
                                                                 }}>
                                                                      📄
                                                                 </span>
                                                                 <div>
                                                                      <div style={{ 
                                                                           fontWeight: '600', 
                                                                           fontSize: '13px',
                                                                           color: '#2c3e50',
                                                                           marginBottom: '2px'
                                                                      }}>
                                                                           {fileInfo.fileName.length > 25 ? `${fileInfo.fileName.substring(0, 25)}...` : fileInfo.fileName}
                                                                      </div>
                                                                      <div style={{ 
                                                                           fontSize: '11px', 
                                                                           color: '#6c757d',
                                                                           display: 'flex',
                                                                           alignItems: 'center'
                                                                      }}>
                                                                           <span style={{ 
                                                                                backgroundColor: '#e2e3e5',
                                                                                color: '#495057',
                                                                                padding: '2px 6px',
                                                                                borderRadius: '12px',
                                                                                fontSize: '10px',
                                                                                fontWeight: '500'
                                                                           }}>
                                                                                {fileInfo.fileType || 'Document'}
                                                                           </span>
                                                                      </div>
                                                                 </div>
                                                            </div>
                                                       </div>
                                                       <div className="col-4 text-right">
                                                            <button 
                                                                 className="btn btn-sm"
                                                                 style={{
                                                                      backgroundColor: '#6c757d',
                                                                      borderColor: '#6c757d',
                                                                      color: 'white',
                                                                      fontSize: '11px',
                                                                      padding: '4px 8px',
                                                                      borderRadius: '4px'
                                                                 }}
                                                                 onClick={() => this.downloadUanFileFromUrl(fileInfo.downloadUrl, fileInfo.fileName)}
                                                                 title={`Download ${fileInfo.fileName}`}
                                                            >
                                                                 📥 Download
                                                            </button>
                                                       </div>
                                                  </div>
                                             </div>
                                                  ))}
                                             </div>
                                        ) : (
                                             <div style={{ 
                                                  padding: '10px', 
                                                  backgroundColor: '#fff3cd', 
                                                  border: '1px solid #ffeaa7', 
                                                  borderRadius: '6px',
                                                  fontSize: '12px',
                                                  color: '#856404'
                                             }}>
                                                  ⚠️ No downloadable UAN files found
                                             </div>
                                        );
                                   })()
                              ) : this.props.data === 'UAN Report Data' && value && typeof value === 'object' && value !== 'No UAN Report Data Available' ? (
                                   <div style={{ 
                                        padding: '10px', 
                                        backgroundColor: '#e7f3ff', 
                                        border: '1px solid #b3d9ff', 
                                        borderRadius: '6px'
                                   }}>
                                        <div style={{ marginBottom: '6px', fontWeight: '600', fontSize: '12px', color: '#004085' }}>
                                             📊 UAN Report Summary:
                                        </div>
                                        <div style={{ fontSize: '11px', color: '#495057' }}>
                                             {value.uan ? (
                                                  <div style={{ marginBottom: '2px' }}>
                                                       <strong>UAN:</strong> {value.uan}
                                                  </div>
                                             ) : null}
                                             {value.records && Array.isArray(value.records) ? (
                                                  <div style={{ marginBottom: '2px' }}>
                                                       <strong>Employment Records:</strong> {value.records.length}
                                                  </div>
                                             ) : null}
                                             {value.verificationDate ? (
                                                  <div style={{ marginBottom: '2px' }}>
                                                       <strong>Verification Date:</strong> {new Date(value.verificationDate).toLocaleDateString()}
                                                  </div>
                                             ) : null}
                                        </div>
                                   </div>
                              ) : this.props.data === 'UAN Number' && value && value.trim() !== '' ? (
                                   <div style={{ 
                                        padding: '8px 12px', 
                                        backgroundColor: '#d1ecf1', 
                                        border: '1px solid #bee5eb', 
                                        borderRadius: '6px',
                                        display: 'inline-block'
                                   }}>
                                        <span style={{ fontSize: '12px', fontWeight: '600', color: '#0c5460' }}>
                                             🆔 {value}
                                        </span>
                                   </div>
                              ) : this.props.data === 'Process Status' && value ? (
                                   <div style={{ 
                                        padding: '4px 8px', 
                                        backgroundColor: value === 'Completed' ? '#d4edda' : value === 'Failed' ? '#f8d7da' : '#fff3cd',
                                        border: value === 'Completed' ? '1px solid #c3e6cb' : value === 'Failed' ? '1px solid #f5c6cb' : '1px solid #ffeaa7',
                                        borderRadius: '12px',
                                        display: 'inline-block'
                                   }}>
                                        <span style={{ 
                                             fontSize: '11px', 
                                             fontWeight: '600',
                                             color: value === 'Completed' ? '#155724' : value === 'Failed' ? '#721c24' : '#856404'
                                        }}>
                                             {value === 'Completed' ? '✅' : value === 'Failed' ? '❌' : '⏳'} {value}
                                        </span>
                                   </div>
                              ) : (
                                   (() => {
                                        // Sanitize generic values to avoid showing placeholder files like null.png/null.jpg
                                        if (typeof value === 'string') {
                                             const trimmed = value.trim()
                                             const isHidden = !trimmed || trimmed === 'null' || trimmed === 'undefined' ||
                                                  trimmed.toLowerCase() === 'na' ||
                                                  trimmed.includes('null.png') || trimmed.includes('null.jpg') || trimmed.includes('null.jpeg')
                                             if (isHidden) {
                                                  return <div className="smallfont body2"> - </div>
                                             }
                                        }
                                        return (
                                             <div className="smallfont body2">
                                                  {value && typeof value === 'object' ?
                                                       'Object data (not displayable)' :
                                                       (value ? value : ' - ')
                                                  }
                                             </div>
                                        )
                                   })()
                              )}
                              
                              <div className="clr10"></div>
                         </div>
                    }
                    {showReassignVendor ?
                         <React.Fragment>
                              <div className="col-12 col-sm-6 mb15">
                                   <div className="form-group ml5 mr5">
                                        {this.state.vendorOptions.length ?
                                             <React.Fragment>
                                                  <label className="sub-heading1">{"Choose a vendor to Assign/Reassign"}</label>
                                                  <Select
                                                       id="vendorId"
                                                       styles={{
                                                            control: (provided, state) => ({
                                                            ...provided,
                                                            border: "1px solid #D4DBFF",
                                                            borderRadius: 8,
                                                             
                                                            }),
                                                       }}
                                                       options={this.state.vendorOptions}
                                                       value=''
                                                       onChange={this.onVendorChange}
                                                  ></Select>
                                             </React.Fragment> : "No vendors available to reassign "}
                                   </div>
                              </div>
                         </React.Fragment>
                         : null
                    }
                    <ConfirmationModal
                         show={this.state.showConfirmationModal}
                         heading="Are you sure ?"
                         subheading={this.state.subheading}
                         successButtonText="Yes"
                         failureButtonText="No"
                         successCallback={() => { this.confirmSuccessCallback() }}
                         failureCallback={() => { this.setState({ showConfirmationModal: false }) }}
                         closeCallback={() => { this.setState({ showConfirmationModal: false }) }}
                    ></ConfirmationModal>
                    {openAddressDetailsModal ? <div className="modal-dialog ">
                         <DialogModal
                              show={this.state.openAddressDetailsModal}
                              header="Enter Address Details"
                              successButtonText="Submit"
                              failureButtonText="Cancel"
                              onHide={this.hideModal}
                              className="cibil-popup emp_modal"
                              showFooter="false"
                         >
                              <AddressDetailsModal
                                   id={this.props.caseId}
                                   successCallback={this.props.cbRender}
                                   hideModal={this.hideModal}
                              />
                         </DialogModal>
                    </div> : null}
               </React.Fragment>
          );
     }

}
export default withTranslation('translations')(VerificationStatusDetails);


